export const takePictureSettings = {
    components: [
        {
            type: 'tabs',
            key: 'tabs',
            components: [
                {
                    key: 'display',
                    components: [
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'label',
                            defaultValue: 'Camera',
                            label: 'Label',
                            placeholder: 'Field Label',
                            tooltip: 'The label for this field that will appear next to it.',
                            validate: {
                                required: true
                            }
                        },
                        {
                            type: 'select',
                            input: true,
                            key: 'labelPosition',
                            label: 'Label Position',
                            tooltip: 'Position for the label for this field.',
                            weight: 20,
                            defaultValue: 'top',
                            dataSrc: 'values',
                            data: {
                                values: [
                                    { label: 'Top', value: 'top' },
                                    { label: 'Left (Left-aligned)', value: 'left-left' },
                                    { label: 'Left (Right-aligned)', value: 'left-right' },
                                    { label: 'Right (Left-aligned)', value: 'right-left' },
                                    { label: 'Right (Right-aligned)', value: 'right-right' },
                                    { label: 'Bottom', value: 'bottom' }
                                ]
                            }
                        },
                        {
                            weight: 500,
                            type: 'textfield',
                            input: true,
                            key: 'customClass',
                            label: 'Custom CSS Class',
                            placeholder: 'Custom CSS Class',
                            tooltip: 'Custom CSS class to add to this component.'
                        },
                        {
                            weight: 1200,
                            type: 'checkbox',
                            label: 'Hide Label',
                            tooltip: 'Hide the label of this component.',
                            key: 'hideLabel',
                            input: true,
                            defaultValue: false
                        },
                        {
                            weight: 1400,
                            type: 'checkbox',
                            label: 'Disabled',
                            tooltip: 'Disable the form input.',
                            key: 'disabled',
                            input: true
                        }
                    ],
                    label: 'Display',
                    weight: 0
                },
                {
                    key: 'data',
                    components: [
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'fileDataKey',
                            label: 'File Data Key',
                            placeholder: 'File Data Key',
                            tooltip: 'To set the key name of the file details',
                            validate: {}
                        }
                    ],
                    label: 'Data',
                    weight: 10
                }
            ]
        }
    ]
};
